
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class ModalConfirmTAC extends Vue {
  /* VUEX */

  /* ACTION */

  /* STATE */

  /* PROPS */
  @Prop({ default: false })
  private isShow: boolean;

  /* INITIALIZATION */
  private term_and_condition =
    "Dengan mengklik tombol ini, Anda bertindak atas nama Kepala Sekolah telah setuju dengan syarat dan ketentuan yang ditetapkan oleh Career Support dalam penyelenggaraan Virtual Job Fair.Term and Condition Virtual Job Fair Career Support Indonesia1.   Career Support Indonesia adalah penyedia sistem virtual job fair yang dapat digunakan oleh BKK Mitra Career Support 2.   BKK Mitra Career Support berperan dalam mendaftarkan virtual job fair, melakukan promosi kepada perusahaan dan siswa, serta mengelola kebutuhan virtual job fair3.   Untuk menggunakan fitur virtual job fair, BKK Mitra Career Support harus memenuhi syarat sebagai berikut:a.   memiliki sekurang-kurangnya 3 (tiga) perusahaan yang akan bergabung menjadi perusahaan peserta virtual job fairb.   memiliki sekurang-kurangnya 50 (lima pulih) siswa dan alumni yang akan bergabung menjadi peserta virtual job fairc.    membentuk panitia yang berisikan sekurang-kurangnya 3 (tiga) orang dengan pembagian tugas yang disesuaikan dengan kebutuhan virtual job fair Andad.   memiliki bahan publikasi yang akan digunakan sebagai bahan promosi untuk perusahaan dan siswa peserta virtual job fair4.   Untuk mendukung penyelenggaraan virtual job fair secara optimal, hubungi customer relation Career Support untuk melakukan konsultasi kebutuhan virtual job fair Anda5.   Pelaksanaan dan kesuksesan virtual job fair sepenuhnya menjadi tanggung jawab BKK mitra career support sebagai penyelenggara kegiatan";

  /* METHODS */
  private clickEnd() {
    localStorage.setItem("accept_tac_jobfair", "accept");
    this.$emit("on-accept");
  }
}
